/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/date-utils/get-valid-full-year */
import { getFloorAt } from '../../number-utils/internals/get-floor-at.js';
/**
 * @description Converts a two digit short year to the most probable full year match.
 * @param {number} shortYear - Short year to be converted.
 * @returns {number} Matched full year.
 */

function getValidFullYear(shortYear) {
  var fullYear = new Date().getFullYear();
  var base = getFloorAt(fullYear, -2);
  var prevBase = getFloorAt(base - 1, -2);
  var min = fullYear - base;
  var max = 99;

  if (shortYear <= min) {
    return base + shortYear;
  } else if (shortYear <= max) {
    return prevBase + shortYear;
  } else {
    return shortYear;
  }
}

export { getValidFullYear };